var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "arrow-left_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.402 21.813 4.215 32l20.434 20.435 2.837-2.836-15.585-15.586h48.586v-4.026H11.901l15.585-15.586-1.388-1.388c-.764-.763-1.416-1.387-1.45-1.387-.032 0-4.644 4.584-10.246 10.187",
    clipRule: "evenodd"
  })));
};
export { SvgArrowLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE0LjQwMTUgMjEuODEzTDQuMjE0NiAzMkwyNC42NDg5IDUyLjQzNDZMMjcuNDg2NCA0OS41OTlMMTEuOTAwNyAzNC4wMTNINjAuNDg3VjI5Ljk4N0gxMS45MDA3TDI3LjQ4NjQgMTQuNDAwOUwyNi4wOTc5IDEzLjAxMzRDMjUuMzM0MyAxMi4yNTAzIDI0LjY4MjIgMTEuNjI2IDI0LjY0ODkgMTEuNjI2QzI0LjYxNTYgMTEuNjI2IDIwLjAwNDMgMTYuMjEwMSAxNC40MDE1IDIxLjgxM1oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";